import { render, staticRenderFns } from "./ConfigOptions.vue?vue&type=template&id=6282df8d&"
import script from "./ConfigOptions.vue?vue&type=script&lang=js&"
export * from "./ConfigOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6282df8d')) {
      api.createRecord('6282df8d', component.options)
    } else {
      api.reload('6282df8d', component.options)
    }
    module.hot.accept("./ConfigOptions.vue?vue&type=template&id=6282df8d&", function () {
      api.rerender('6282df8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/vistas/ConfigOptions.vue"
export default component.exports